export default __webpack_public_path__ + "static/media/5.80a60476.png";